import React from 'react';
import { useParams } from 'react-router-dom';
import { ExportState, useExports } from '../../shared';
import Page from '../templates/Page';

export default function Exports() {
    const { id } = useParams();
    const { exports } = useExports(id || "-1");
    return (
        <Page>
            <div style={{ color: "white" }}>
            <h1>Exports</h1>
            {exports.map((e: ExportState) => (
                <div key={e.exportId}>
                    <div>{e.process} {e.progress}</div>
                    <div>
                        {e.videoUrl ? (
                            <video
                                src={e.videoUrl}
                                width={300}
                                height={300}
                                controls
                            />
                        ) : (
                            <div style={{ width: 300, height: 300, backgroundColor: "gray" }} />
                        )}
                    </div>
                </div>
            ))}
            </div>
        </Page>
    )
}